import { get, remove } from 'helpers/apiHelpers';
import types from 'helpers/constants';

export const fetchDishes = ({
  pageSize = 30,
  page = 0,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME
  sorted = [],
  filtered = [],
  ...rest
}) => {
  const filters = filtered.reduce((curr, next) => {
    curr[next.id] = next.value;
    return curr;
  }, {});

  return dispatch =>
    get('/dishes', {
      itemsPerPage: pageSize,
      page: page + 1,
      ...filters,
      id: filters.id,
      nameForClient: filters.name,
      ingredientName: filters.ingredients,
      tags: filters.tags,
      partial: false,
      ...rest,
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    }).then(response => {
      dispatch({
        type: types.FETCH_DISHES,
        payload: {
          dishes: response['hydra:member'],
          pages: Math.ceil(response['hydra:totalItems'] / pageSize),
        },
      });

      return response['hydra:member'];
    });
};

export const removeDish = id => dispatch =>
  // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  remove(`/dishes/${id}`).then(() => {
    dispatch({
      type: types.REMOVE_DISH,
      payload: {
        removedItemId: id,
      },
    });
  });

export const fetchDish = id => dispatch =>
  // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  get(`/dishes/${id}`).then(response => {
    dispatch({
      type: types.FETCH_DISH,
      payload: {
        dish: response,
      },
    });
    return response;
  });
